module.exports = __webpack_public_path__ + "static/media/state-11.18b762d0.jpg";